<template>
    <Head title="DMARCeye.com registration - DMARC monitoring & reporting">
        <meta
            name="description"
            content="Create your DMARCeye account today and start protecting your domain from spoofing. Set up DMARC monitoring and view reports in minutes."
        />
    </Head>

    <div id="form-container"></div>

    <AuthLayout>
        <div
            class="mt-8 w-full overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-lg"
        >
            <div class="mb-8 mt-[2px] border-b border-gray-200 pb-5">
                <h1 class="text-center text-xl font-bold text-gray-800">
                    {{ props.testHeader }}
                </h1>
            </div>
        </div>

        <div class="mt-11 text-center text-sm text-gray-500">
            {{ props.testHeader }}
        </div>

        <div class="mt-11 text-center text-sm text-gray-500">
            {{ props.testExtra }}
        </div>

        <div
            class="hs-form-frame"
            data-region="eu1"
            data-form-id="d68e6db5-7571-4cbd-a934-9576fc1a96af"
            data-portal-id="146415216"
        ></div>
    </AuthLayout>
</template>

<script lang="ts" setup>
import { Head } from "@inertiajs/vue3";
import { useTranslations } from "@/composables/useTranslations";
import { onMounted } from "vue";

onMounted(() => {
    const s = document.createElement("script");
    s.src = "https://js-eu1.hsforms.net/forms/embed/146415216.js";
    s.defer = true;
    document.body.appendChild(s);
});

const props = defineProps({
    testHeader: {
        required: false,
        type: String,
        default: "",
    },
    testContent: {
        required: false,
        type: String,
        default: "",
    },
    testExtra: {
        required: false,
        type: String,
        default: "",
    },
});

const { t } = useTranslations();
</script>
